
<div class="container">
  <div *ngIf="pageLoading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-file-alt"></i></span>{{ 'VMIDOCreate.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <!-- 搜尋條件 -->
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="showConditionAccordion">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <!-- facility -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.Facility' | translate }}</label>
              <laas-facility-dropdown
                formControlName="facilityList"
                [isMultiple]="true"
                [showFilter]="true"
                [showToggleAll]="true">
              </laas-facility-dropdown>
            </div>
            <!-- plant -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.VendorPlant' | translate }}</label>
              <p-multiSelect
                formControlName="plantList"
                [options]="plantOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <!-- storer -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.Storer' | translate }}</label>
              <p-multiSelect
                formControlName="storerList"
                [options]="storerOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <!-- vendor -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.Vendor' | translate }}</label>
              <laas-multiSelect
                formControlName="vendorList"
                [options]="vendorOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </laas-multiSelect>
              <small class="p-error" *ngIf="searchForm.get('vendorList')?.invalid && searchForm.get('vendorList')?.touched">
                {{ 'Common.Message.Required' | translate }}
              </small>
            </div>
            <!-- brand -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.Brand' | translate }}</label>
              <laas-multiSelect
                formControlName="brandList"
                [options]="brandOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </laas-multiSelect>
            </div>
            <!-- manufacturerPartNumber -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.ManufacturerPartNumber' | translate }}</label>
              <input type="text" pInputText formControlName="manufacturerPartNumber">
            </div>
            <!-- sku -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'VMIDOCreate.Search.Sku' | translate }}</label>
              <input type="text" pInputText formControlName="sku">
            </div>
          </div>
        </form>
        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchVMIForm()"></button>
        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn()" class="p-button-secondary ml-2"></button>
        <button pButton pRipple label="{{ 'VMIDOCreate.Button.Upload' | translate }}" icon="pi pi-upload" (click)="showUploadDOModal = true" class="ml-2"></button>
      </p-accordionTab>
    </p-accordion>
    <!-- expandable 顯示明細, lazy實行分頁查詢時的懶加載 -->
    <laas-data-table #searchTable [dataKey]="'seqNo'" [tableKey]="preferenceKey" [value]="searchResults" [loading]="tableLoading" [defaultColumns]="tableColumn"
    (tableOnPage)="tablePageChange($event)" (tableOnSort)="tableSort($event)"
     [lazy]="true"  [expandable]="true" (rowExpanded)="searchDetailClick($event)" >

     <!-- caption -->
      <ng-template pTemplate="caption">

      </ng-template>

      <!-- body table -->
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'doNo'">
              <div class="overflow-text">{{ rowData.doNo }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'facility'">
              <div class="overflow-text">{{ rowData.facility | optionsMapping: facilityOptions |  replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'vendorPlant'">
              <div class="overflow-text">{{ rowData.vendorPlant }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'vendorNo'">
              <div class="overflow-text">{{ rowData.vendorNo | optionsMapping: vendorOptions |  replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'storer'">
              <div class="overflow-text">{{ rowData.storer | optionsMapping: storerOptions |  replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'isBonded'">
              <div class="overflow-text">{{ rowData.isBonded }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'etd'">
              <div class="overflow-text">{{ rowData.etd | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |  replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'deliveryType'">
              <div class="overflow-text">{{ rowData.deliveryType }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'incoTerm'">
              <div class="overflow-text">{{ rowData.incoTerm }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'assignForwarder'">
              <div class="overflow-text">{{ rowData.assignForwarder | optionsMapping: forwarderOptions |  replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'address'">
              <div class="overflow-text">{{ rowData.address }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'createUser'">
              <div class="overflow-text">{{ rowData.createUser }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">{{ rowData.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |  replaceNullWith:'-' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateUser'">
              <div class="overflow-text">{{ rowData.updateUser }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'">
              <div class="overflow-text">{{ rowData.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |  replaceNullWith:'-' }}</div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>

      <!-- expanded template -->
      <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
        <laas-data-table [tableKey]="detailPreferenceKey"  [dataKey]="'seqNo'"
                    [value]="rowData.details" [defaultColumns]="detailColumns"[paginator]="false">
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded>
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'externLineNo'">
                  <div class="overflow-text">{{ rowData.externLineNo }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'sku'">
                  <div class="overflow-text">{{ rowData.sku }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'manufacturerPartNumber'">
                  <div class="overflow-text">{{ rowData.manufacturerPartNumber }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'brand'">
                  <div class="overflow-text">{{ rowData.brand }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'vendorLot'">
                  <div class="overflow-text">{{ rowData.vendorLot }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'vendorDc'">
                  <div class="overflow-text">{{ rowData.vendorDc }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'coo'">
                  <div class="overflow-text">{{ rowData.coo }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'originalQty'">
                  <div class="overflow-text">{{ rowData.originalQty }}</div>
                </ng-container>
              </ng-container>
            </td>
          </ng-template>
        </laas-data-table>
      </ng-template>

    </laas-data-table>
  </p-card>

  <!-- 上傳功能 Dialog -->
  <p-dialog header="{{ 'VMIDOCreate.ImportDODialog.Header' | translate }}" [(visible)]="showUploadDOModal" [style]="{width: '50vw'}" [modal]="true" [baseZIndex]="100" appendTo="body" (onHide)="closedUpploadModal()">
    <div *ngIf="uploadLoading" class="loadingMask">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <input type="file" style="display: none" #fileInput (change)="onFileSelected($event)" accept=".xls,.xlsx">
    <button pButton pRipple label="{{ 'VMIDOCreate.Button.Select' | translate }}" icon="pi pi-check" class="p-button-success mr-2" (click)="fileInput.click()"></button>
    <button pButton pRipple label="{{ 'VMIDOCreate.Button.Upload' | translate }}" icon="pi pi-upload" class="mr-2" (click)="uploadFile()" [disabled]="!selectedFile"></button>
    <button pButton pRipple label="{{ 'VMIDOCreate.Button.DownloadTemplate' | translate }}" icon="pi pi-download" class="p-button-secondary" (click)="downloadTemplate()"></button>
  </p-dialog>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
